module.exports = __webpack_public_path__ + "static/media/logoutIcon.1998915c.svg";